class EnumValue {
  _code;
  _name;
  _desc;
  constructor(code, name, desc) {
    this._code = code
    this._name = name !== undefined ? name : code
    this._desc = desc
  }

  get code() {
    return this._code
  }

  set code(value) {
    console.error('can\'t modify enum value')
  }

  get name() {
    return this._name
  }

  set name(value) {
    console.error('can\'t modify enum value')
  }

  get desc() {
    return this._desc
  }

  set desc(value) {
    console.error('can\'t modify enum value')
  }
}

function enumValue(code, name, desc = '') {
  return new EnumValue(code, name, desc)
}

export {
  EnumValue,
  enumValue,
}
